import React, {Fragment} from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'

import ModalCreateCompraDirecta from './ModalCreateCompraDirecta'
import ModalSelectorFromList from '../../components/Shared/ModalSelectorFromList'
import ModalConfirmarAccion from '../../components/Shared/ModalConfirmarAccion'
import BoxButton from '../Layout/BoxButton';

import { displayModalCompraDirecta } from '../../actions/solicitudservicio'
import { downloadFile } from '../../actions/common'

import { isAllowedToViewComponent, getDivisa, formatcoin } from '../../utils/helpers'


class CompraDirectaServicio extends React.Component {


    render() {
        
        const { id, solicitudservicio, divisas, displayModalCompraDirecta } = this.props
        //console.log("# entrada datos desde despues de aprobaciones",solicitudservicio.toJS())
        const medios_pago = {
            tarjeta_debito: 'Tarjeta Débito',
            tarjeta_credito: 'Tarjeta Crédito',
            caja_menor: 'Caja Menor'
        }
        if (!id) return null

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Producto</th>
                                    <th>Cantidad</th>
                                    <th>Nombre razon social</th>
                                    <th>NIT</th>
                                    <th>No. Factura</th>
                                    <th>Fecha compra</th>
                                    <th>Forma de pago</th>
                                    <th>Valor compra</th>
                                    <th>Adjuntar factura</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                     solicitudservicio.get('cotizaciones').filter(c =>  c.get('proveedore') == null && c.getIn(['aprobaciones','0','estado']) == 2).map((cot) => {

                                        const moneda = cot.get('moneda');
                                        const divisa = getDivisa(divisas, moneda)                                       
                                    
                                        return cot.get('servicios').filter(servicios => servicios.get('compra_directa')).map(a =>
                                        (
                                            <tr key={`tr4[${a.get('id')}]`}>
                                                <td style={{ padding: '0' }}>
                                                <BoxButton size={ 12 } name="pencil" disabled={!!a.getIn(['factura_compra_directa_servicios', 'id']) || !isAllowedToViewComponent('responsable_compras', this.props.solicitudservicio)}
                                                    onClick={() => displayModalCompraDirecta(true, 'Registrar Compra Directa', a.get('id'), cot)}
                                                    />
                                                </td>
                                                <td>{a.get('descripcion')}</td>
                                                <td style={{ textAlign: 'right' }}>{a.getIn(['cantidad'])}</td>
                                                <td>{a.getIn(['factura_compra_directa_servicios', 'razon_social']) || cot.get('proveedor_nombre_cp') || ''}</td>
                                                <td>{a.getIn(['factura_compra_directa_servicios', 'nit'])}</td>
                                                <td style={{ textAlign: 'right' }}>{a.getIn(['factura_compra_directa_servicios', 'no_factura'])}</td>
                                                <td>{moment(a.getIn(['factura_compra_directa_servicios', 'fecha_compra'])).format('YYYY-MM-DD')}</td>
                                                <td>{medios_pago[a.getIn(['factura_compra_directa_servicios', 'medio_pago'])]}</td>
                                                <td>{formatcoin(a.getIn(['factura_compra_directa_servicios', 'valor_compra']), divisa.simbolo)}</td>
                                                {
                                                    a.getIn(['factura_compra_directa_servicios', 'adjunto_id']) ? (
                                                        <td style={{ cursor: 'pointer' }} onClick={() => this.props.downloadFile(a.getIn(['factura_compra_directa_servicios', 'adjunto', 'id']), a.getIn(['factura_compra_directa_servicios', 'adjunto', 'nombre']))}>
                                                            <i className="fa fa-download"></i>
                                                            <span style={{ marginLeft: '3px' }}>{`${a.getIn(['factura_compra_directa_servicios', 'adjunto', 'nombre'])}`}</span>
                                                        </td>
                                                    ) : (
                                                        <Fragment>
                                                            {a.getIn(['factura_compra_directa_servicios', 'adjunto']) ? (                                                                
                                                                <td>
                                                                    <span style={{ marginLeft: '3px' }}>{`${a.getIn(['factura_compra_directa_servicios', 'adjunto', 'nombre'])}`}</span>
                                                                </td>
                                                            ):(
                                                                <td style={{ cursor: 'not-allowed' }}>
                                                                    <span style={{ marginLeft: '3px' }}>Archivo sin adjuntar</span>
                                                                </td>
                                                            )}
                                                        </Fragment>
                                                    )
                                                }
                                            </tr>
                                        ))
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
               <ModalCreateCompraDirecta displayModalAddFile={ this.props.displayModalAddFile } />
                <ModalSelectorFromList />
                <ModalConfirmarAccion />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        id: state.solicitudservicio.get('id'),
        solicitudservicio: state.solicitudservicio.get('solicitud'),
        enums: state.common.get('enums').toJS(),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalCompraDirecta: (show, title, servicio_id, cotizacion) => dispatch(displayModalCompraDirecta(show, title, servicio_id, cotizacion)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompraDirectaServicio)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/CompraDirecta.jsx